import { Link } from "react-router-dom";
import content from "../../data/content";
import "./Footer.css";

const { footer, global: brand, navigation } = content;

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <Link to="/" className="footer__logo">
            {brand.siteNameShort}
          </Link>
          <p className="footer__tagline">{brand.siteName}</p>
        </div>

        <nav className="footer__links">
          {navigation.links.map((link) => (
            <Link key={link.path} to={link.path} className="footer__link">
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="footer__contact">
          <a
            href={brand.line.url}
            className="footer__social"
            target="_blank"
            rel="noopener noreferrer"
          >
            LINE {brand.line.handle}
          </a>
          <a
            href={brand.instagram.url}
            className="footer__social"
            target="_blank"
            rel="noopener noreferrer"
          >
            {brand.instagram.handle}
          </a>
        </div>
      </div>

      <div className="footer__bottom">
        <p>{footer.copyright}</p>
      </div>
    </footer>
  );
}
